import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { getLastPrice, updateSubscription } from '@/api/billing';
import { Price, SubscriptionStatusUpdate } from '@/api/typings/billing';
import { StoreType } from '@/typings/user';
import { AxiosError } from 'axios';
import { Ref, computed, onBeforeMount, ref } from 'vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionResumeDialog',
  props: {
    value: { type: Boolean },
    store: null,
    subscriptionId: null
  },
  emits: ['input', 'resumed'],
  setup(__props: any, { emit }) {

const props = __props as {
    value: boolean;
    store: string;
    subscriptionId?: string;
};





const password = ref('');
const resumingSubscription = ref(false);
const resumeSubscriptionError = ref(false);
const invalidPassword = ref(false);
const lastPrice: Ref<null | Price> = ref(null);
const isShopifySubscription = ref(false);

const user = computed(() => store.state.user);

const isVisible = computed({
    get(): boolean {
        return props.value;
    },
    async set(value: boolean) {
        if (value) {
            resumeSubscriptionError.value = false;
            invalidPassword.value = false;
            password.value = '';

            if (props.store) {
                try {
                    lastPrice.value = await getLastPrice(props.store);
                } catch (error) {
                    const axiosError = error as AxiosError;
                    lastPrice.value = null;
                    if (axiosError.response?.status !== 400) {
                        window.rumReportError(axiosError);
                    }
                }
            } else {
                console.warn(`No store given on SubscriptionResumeDialog`);
            }
        }
        emit('input', value);
    }
});

onBeforeMount(() => {
    const store = user.value?.Stores.find((store) => store.Url == props.store);
    if (store) {
        isShopifySubscription.value = store.Type === StoreType.Shopify;
    }
});

const resumeSubscriptionSubmit = async () => {
    if (!props.store) {
        console.warn(`No store given on SubscriptionResumeDialog`);
        return;
    }

    try {
        resumingSubscription.value = true;
        if (password.value && props.subscriptionId) {
            resumeSubscriptionError.value = false;
            const result = await updateSubscription(props.store, password.value, SubscriptionStatusUpdate.Active);

            // If we have a confirmation URL we have to redirect the user to confirm the subscription there
            if (result.ConfirmationUrl) {
                location.href = result.ConfirmationUrl;
            } else {
                emit('resumed', props.subscriptionId);
                isVisible.value = false;
            }
        }
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response?.status === 400) {
            if (axiosError.response.data.Message) {
                if (axiosError.response.data.Message === 'Invalid Password') {
                    invalidPassword.value = true;
                } else {
                    resumeSubscriptionError.value = true;
                }
            }
        } else {
            resumeSubscriptionError.value = true;
            window.rumReportError(axiosError);
        }
    } finally {
        resumingSubscription.value = false;
    }
};

return { __sfc: true,props, emit, password, resumingSubscription, resumeSubscriptionError, invalidPassword, lastPrice, isShopifySubscription, user, isVisible, resumeSubscriptionSubmit, BModal, LoaderBtn, ValidationProvider, ValidationObserver }
}

})